import { localUser } from "@util/utils";

export const handleInitialFormData = (sourceData) => {
    const currentEmployee = localUser.get('employee') || {};
    return {
        ...sourceData,
        employeeID: sourceData?.employeeID || currentEmployee?.employeeID
    }
}
